<template>
    <el-dialog title="追踪信息" :visible.sync="visible" @close="close" v-loading="loading">
        <el-row>
            <el-col :xs="24" :sm="24" :md="24" :lg="24">
                追踪信息描述
            </el-col>
        </el-row>
        <el-row>
            <el-col :xs="24" :sm="24" :md="24" :lg="24">
                <el-input maxlength="120" type="textarea" rows="5" v-model="description"></el-input>
            </el-col>
        </el-row>
        <br>
        <el-row>
            <el-col :xs="24" :sm="24" :md="12" :lg="12">
                <el-upload
                        ref="upload"
                        :http-request="prepareFiles"
                        :before-upload="beforeAvatarUpload"
                        :on-remove="handleRemove">
                    <div v-if="btnVisible">
                        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                        <div slot="tip" class="el-upload__tip">附件大小不允许超过{{attachmentMaxSize}}MB</div>
                    </div>
                </el-upload>
            </el-col>
        </el-row>

        <div slot="footer" class="dialog-footer">
            <el-button @click="cancelFunc">取 消</el-button>
            <el-button type="primary" @click="confirmFunc">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import CommonApi from "@/api/common";

    export default {
        name: "trackInfo",

        props: {
            visible: {
                type: Boolean,
            },

            ownerId: {
                type: Number,
            },

            ownerTable: {
                type: String,
            },

            docType: {
                type: String,
            },

            attachmentMaxSize: {
                type: Number,
                default: 10,
            },

        },

        data() {
            return {
                description: '',

                uploadFileArr: [],

                btnVisible: true,

                loading: false,
            }
        },

        methods: {
            close() {
                this.description = '';
                this.uploadFileArr = [];
                this.$refs['upload'].clearFiles();
                this.$emit('update:visible', false);
            },

            prepareFiles(e) {
                this.uploadFileArr.push(e.file);
            },

            beforeAvatarUpload(file) {
                // const sizeIsValid = file.size <= this.attachmentMaxSize * 1024 * 1024;
                // if (!sizeIsValid) {
                //     this.$message.error(`附件大小不允许超过${this.attachmentMaxSize}MB!`);
                // }
            },

            cancelFunc() {
                this.close();
            },

            handleRemove(file, fileList) {
                this.uploadFileArr = [];
            },

            confirmFunc() {
                let file = this.uploadFileArr == null ? null : this.uploadFileArr[0];
                if(file){
                    const sizeIsValid = file.size <= this.attachmentMaxSize * 1024 * 1024;
                    if (!sizeIsValid) {
                        this.$message.error(`附件大小不允许超过${this.attachmentMaxSize}MB!`);
                        this.uploadFileArr = [];
                        this.$refs['upload'].clearFiles();
                        return;
                    }
                }

                this.loading = true;

                CommonApi.insertTrackInfo(this.ownerId, this.ownerTable, this.docType, this.description, file, localStorage.getItem('userid')).then(res => {
                    this.$message.success("追踪添加成功");
                    this.$emit('afterInsertTrackInfo');
                    this.loading = false;
                }).catch(e => {
                    this.loading = false;
                    console.error(e);
                });
            },
        },

        watch: {
            uploadFileArr: {
                immediate: true,
                handler: function (newVal, oldVal) {
                    if (newVal.length > 0) {
                        this.btnVisible = false;
                    } else {
                        this.btnVisible = true;
                    }
                }
            }
        }

    }
</script>

<style scoped>

</style>